
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import {httpResource} from "@/resources/http.resource";
  import {Barrier} from "@/modules/barriers/interfaces/barrier.interface";
  import {IBook} from "@/interfaces/book.interface";

  @Component({
    components: {
      AppDialog,
    },
  })
  export default class DemoMovesPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'barriers', dialogName: 'demoMoves' };
    carNumber = '';
    manualInput = true;

    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }
    get carsBook(): Barrier.IDemoCarsBook[] {
      let bookArray = this.$store.state.book.books[IBook.BookName.demoCars];
      let storageArray = [];
      let storageValue = localStorage.getItem(Barrier.LocalStorageKeys.DemoMovesNumberArray);
      if (storageValue) {
        storageArray = JSON.parse(storageValue).map(item => { return { carNumber: item, name: item }; });
      }
      return [ ...storageArray, ...bookArray,];
    }

    async mounted() {
      this.carNumber = localStorage.getItem(Barrier.LocalStorageKeys.DemoMovesNumber) || '';

      if (this.carNumber) {
        await this.$nextTick();
        const inputNumber: any = this.$refs.inputNumber.$refs.input;
        inputNumber.focus();
        await this.$nextTick();
        inputNumber.setSelectionRange(0, inputNumber.value.length);
      }

      await this.$store.dispatch('book/getBook', { bookNames: [IBook.TableName.demoCars] });
    }

    validateValue() {
      this.manualInput = true;
      this.carNumber = this.carNumber
        .replace(/[^0-9a-zа-яё\s]/gi, "")
        .trim()
        .slice(0, 10);
    }

    async confirmAction() {
      if (this.carNumber) localStorage.setItem(Barrier.LocalStorageKeys.DemoMovesNumber, this.carNumber);
      if (this.manualInput) {
        let storageArray = localStorage.getItem(Barrier.LocalStorageKeys.DemoMovesNumberArray);
        let resultArray = [];
        if (storageArray) {
          resultArray = JSON.parse(storageArray);
          let index = resultArray.findIndex(item => item === this.carNumber);
          if (index < 0) {
            resultArray.unshift(this.carNumber);
            resultArray.splice(3, 1);
          }
        }
        else {
          resultArray = [this.carNumber];
        }
        localStorage.setItem(Barrier.LocalStorageKeys.DemoMovesNumberArray, JSON.stringify(resultArray));
      }
      let asyncAction = async () => {
        const params: any = {
          command: Barrier.Commands.SetDemoMoves,
          cameraId: this.payloadPopup.cameraId,
          carNumber: this.carNumber,
        };
        await httpResource.httpAction({ action: Barrier.Action.GateInfo, params });
        await this.onClose();
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }

    async clearGate() {
      this.manualInput = false;
      this.carNumber = '';
      await this.confirmAction();
    }

    dropdownMenuHandle(carNumber: string) {
      this.manualInput = false;
      this.carNumber = carNumber;
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }
  }
